export { default } from './CurrentSharesContainer'
